// extracted by mini-css-extract-plugin
export default {"bar":"pnlGq","innerSize--full":"Zwh2Y"};